module.exports = __webpack_public_path__ + "static/icon-4347f3e2f513c778b797a05f01003372.jpg";